export default __webpack_public_path__ + "static/media/users.e2a482d2.svg";